import { render, staticRenderFns } from "./BottomTabbar.vue?vue&type=template&id=4ab5588c&scoped=true"
import script from "./BottomTabbar.vue?vue&type=script&lang=ts"
export * from "./BottomTabbar.vue?vue&type=script&lang=ts"
import style0 from "./BottomTabbar.vue?vue&type=style&index=0&id=4ab5588c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab5588c",
  null
  
)

export default component.exports